.container {
}

.image {
  object-fit: cover;
  width: 90px;
  height: 90px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.3);
}

.defaultImage {
  object-fit: contain;
}

.status {
  border-radius: 12px;
  padding: 4px 8px;
}
